import "./App.css";
import { Routes, Route } from "react-router-dom";
import Layout from "./Pages/Layout";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Notices from "./Pages/Notices";
import Recruitment from "./Pages/Recruitment";
import Admission from "./Pages/Admission";
import Contact from "./Pages/Contact";
import Payment from "./Pages/Payment";
import { Gallery } from "./Pages/Gallery";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";
import RefundPolicy from "./Pages/RefundPolicy";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="notice" element={<Notices />} />
          <Route path="recruitment" element={<Recruitment />} />
          <Route path="admission" element={<Admission />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacypolicy" element={<PrivacyPolicy />} />
          <Route path="terms&conditions" element={<TermsAndConditions />} />
          <Route path="cancellation/refundpolicy" element={<RefundPolicy />} />
          {/* <Route path="payment" element={<Payment />} /> */}
          <Route path="gallery" element={<Gallery />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
